const invoiceCurrencyReducer = (invoice_currency = "all", action) => {
    switch (action.type) {
        case "ADD_INVOICE_CURRENCY":
            return action.payload;
        default:
            return invoice_currency;
    }
};

export default invoiceCurrencyReducer;